import { FormikErrors, FormikTouched, FormikValues } from 'formik';
import { DataField, FormField } from './dataType';

export const LabelField: React.FC<{
    field: DataField | FormField;
    dirty: boolean;
    errors: FormikErrors<FormikValues>;
    touched: FormikTouched<FormikValues>;
    locale: string;
    className?: string;
}> = ({ field, dirty, errors, touched, locale, className }) => (
    <label
        className={`block text-gray-900 ${className || ''}`}
        htmlFor={field.name}
    >
        {field.title[locale]}
        {dirty && touched[field.name] && errors[field.name] && (
            <div className="ml-0 mt-1 text-xs text-red-700">{`* ${
                errors[field.name]
            }`}</div>
        )}
    </label>
);
